import { styled } from "styled-components"
import { langSelector, langState } from "../../../state/langState"
import { useRecoilValue } from "recoil"
import { Heading1, T5 } from "../../../style/constant"

const More = () => {
  const currentLang = useRecoilValue(langState)
  const Text = useRecoilValue(langSelector)
  return(
    <Container>
      <Title currentLang={currentLang}>{Text.more.text}</Title>
      <ContactButton>Go</ContactButton>
    </Container>
  )
}

export default More

interface Props {
  currentLang:boolean;
}

const Container = styled.section`
  height:382px;
  background-color: #060C17;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Title = styled.h2<Props>`
  ${props => props.currentLang ? 
  `
    ${Heading1}
  `
  :
  `
    ${T5}
  `
  }
`

const ContactButton = styled.button`
  margin-top: 20px;
  font-family: 'Pretendard';
  font-weight: 400;
  font-size: 21px;
  line-height: 125%;
  padding: 16px 54px;
  background-color: #101A2F;
  color:#1B76FF;
  border:none;
  border-radius: 6px;
  :hover{
    color:#fff;
    background:#fff;
    border:1px solid #276BFF;
  }
`